import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { Flex } from 'reflexbox';

import Text from 'components/Text';
import Button from 'components/Button';

import MiniProduct from 'Favourites/components/MiniProduct';

import { getAllTextNotifications } from 'helpers/Notifications';

import { retrieveValue } from 'helpers/i18n';

export default class Notify extends Component {
    constructor(props) {
        super(props);
        const textNotificationsMappings = getAllTextNotifications();

        this.notifications = {
            ...Object.assign({}, ...Object.keys(textNotificationsMappings).map(k => ({[k]: {textComponent: this.getTextComponent(textNotificationsMappings[k]), text: this.getRawText(textNotificationsMappings[k])}}))),
            PRODUCT_ADDED: {
                body: ({items}) => {
                    const addedProducts = items.map(article => <MiniProduct key={article} productId={article}/>);
                    const headingText = addedProducts.length > 1 ? <Text textKey="product_added_toastr_multiple" options={{nrItems: addedProducts.length}}/> : <Text textKey="product_added_toastr_single" />;

                    return ({closeToast}) => {
                        return <div>
                            <h2>{headingText}</h2>
                            <Flex wrap justify="center">
                                {addedProducts}
                            </Flex>
                            {window.Checkout.settings.checkout.url !== '' &&
                                <Button
                                    theme="primary"
                                    text="product_added_toastr_button"
                                    onClick={() => {
                                        window.location.href = window.Checkout.settings.checkout.url;
                                        closeToast();
                                    }}
                                />
                            }
                        </div>;
                    };
                },
                textComponent: this.getTextComponent('product_add_error_invalid_qti_toastr'),
                text: this.getRawText('product_add_error_invalid_qti_toastr'),
            },
            PRODUCT_ADDED_TO_LIST: {
                body: ({items}) => {
                    const addedProducts = items.map(article => <MiniProduct
                        data={article}
                        productId={article.articleNumber}
                        key={article.articleNumber}
                    />);
                    const headingText = addedProducts.length > 1 ? <Text textKey="product_added_to_list_toastr_multiple" options={{nrItems: addedProducts.length}}/> : <Text textKey="product_added_to_list_toastr_single" />;

                    return () => {
                        return <div>
                            <h2>{headingText}</h2>
                            <Flex wrap justify="center">
                                {addedProducts}
                            </Flex>
                        </div>;
                    };
                },
            },
            PRODUCT_ADD_ERROR_INVALID_QTI: {
                body: (notification) => {
                    return <div>{notification.items[0].ProductName.$} <Text textKey="product_add_error_invalid_qti_toastr" /></div>;
                },
            },
        };
    }

    shouldComponentUpdate(nextProps) {
        if (Object.keys(nextProps.notifications).length) {
            return true;
        }
        return false;
    }

    componentDidUpdate() {
        const { removeToastr, notifications } = this.props;

        for (const key in notifications) {
            if (!this.notifications.hasOwnProperty(key)) {
                // eslint-disable-next-line no-console
                console.error('SHOPPINGLIST: missing key', key);
                continue;
            }

            if (!Object.keys(this.notifications[key]).length) {
                // eslint-disable-next-line no-console
                console.error('SHOPPINGLIST: missing key', key);
                continue;
            }

            if (toast.isActive(key)) {
                removeToastr(key);
                continue;
            }

            const notificationOptions = {
                position: 'top-left',
                type: notifications[key].type ? notifications[key].type : toast.TYPE.INFO,
                toastId: key,
            };

            let notificationBody = null;
            if (typeof this.notifications[key].body === 'function') {
                notificationBody = this.notifications[key].body(notifications[key]);
            } else {
                notificationBody = this.renderDefaultBody(this.notifications[key].text);
            }

            if (window.Checkout && window.Checkout.analytics && notificationOptions.type !== 'success') {
                // log error to Google Analytics
                // (both the error id and the full error message)
                window.Checkout.analytics.logEvent('error', 'checkout', this.notifications[key].text, {
                    error_id: key,
                });

                // log error to Content Square (primarily to see screen recordings of errors)
                window._uxa = window._uxa || [];
                window._uxa.push(['trackDynamicVariable', {key: 'notification', value: key} ]);
            }

            toast(notificationBody, Object.assign(notificationOptions, this.notifications[key].options));
            removeToastr(key);
        }
    }

    getTextComponent(textKey) {
        if (!window.Checkout || !window.Checkout.text) {
            return null;
        }

        return <Text textKey={textKey} />;
    }

    getRawText(textKey) {
        if (!window.Checkout || !window.Checkout.text) {
            return null;
        }

        return retrieveValue(window.Checkout.text, textKey) || '';
    }

    renderDefaultBody(text) {
        return (
            <div>{text}</div>
        );
    }

    // Notify component doesn't render anything. It only triggers the toast
    render() {
        return null;
    }
}

Notify.propTypes = {
    notifications: PropTypes.object,
    removeToastr: PropTypes.func,
};
